import React from 'react';

interface StatusMessageProps {
  message: string;
  type?: 'error' | 'loading' | 'info';
}

const StatusMessage: React.FC<StatusMessageProps> = ({ message, type = 'info' }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center px-4 sm:px-6 lg:px-8">
        {type === 'loading' && (
          <div className="animate-spin h-8 w-8 border-3 border-orange-500 border-t-transparent rounded-full mx-auto mb-4" />
        )}
        {type === 'error' && (
          <div className="text-red-500 mb-4">
            <svg className="h-8 w-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        )}
        <p className="text-gray-600 font-medium text-sm sm:text-base">{message}</p>
      </div>
    </div>
  );
};

export default StatusMessage;
